// // PictureOpenModal.js
// import React, { useEffect, useState } from "react";
// import { Modal } from "react-bootstrap";
// import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
// import { FaXmark } from "react-icons/fa6";
// import Data from "../CottageItem/DataItems";
// import "swiper/css";
// import "swiper/css/navigation";

// function PictureOpenModal({ clickedImageCategoryId, setClickedImageCategoryId }) {
//     const [images, setImages] = useState([]);
//     const [clickedImage, setClickedImage] = useState(null);
//     const [isModalOpen, setIsModalOpen] = useState(false);

//     const getImageByPosition = (clickedImagePosition) => {
//         if (clickedImagePosition < 0) {
//             setClickedImage(images.length - 1);
//             return images[images.length - 1].image;
//         }
//         if (clickedImagePosition >= images.length) {
//             setClickedImage(0);
//             return images[0].image;
//         }
//         return images[clickedImagePosition].image;
//     };

//     useEffect(() => {
//         if (clickedImageCategoryId !== null) {
//             setIsModalOpen(true);
//             const filteredCategory = Data.filter((item) => item.categoryId === clickedImageCategoryId);
//             setImages(filteredCategory);
//             setClickedImage(0); // Default to the first image in the category
//         }
//     }, [clickedImageCategoryId !== null]);

//     const [imageLoaded, setImageLoaded] = useState(false);

//     useEffect(() => {
//         setImageLoaded(false); // Reset loading flag when image changes
//     }, [clickedImage]);

//     return (
//         <div>
//             {clickedImageCategoryId !== null && isModalOpen && (
//                 <div className={"container"}>
//                     <Modal show={true} onHide={() => setClickedImageCategoryId(null)} centered size="xl" dialogClassName="">
//                         <Modal.Header
//                             className={"p-0 m-0 w-100 flex justify-content-end py-2 px-3"}
//                             style={{ cursor: "pointer" }}
//                             onClick={() => setClickedImageCategoryId(null)}
//                         >
//                             <FaXmark size={20} className={"p-10"} />
//                         </Modal.Header>
//                         <Modal.Body
//                             className="p-2"
//                             style={{
//                                 width: "100%",
//                                 height: "80%",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                             }}
//                         >
//                             <div className="d-flex justify-content-center align-items-center">
//                                 <div
//                                     onClick={() => setClickedImage((prev) => (prev - 1 + images.length) % images.length)}
//                                     style={{ cursor: "pointer", color: "lightgray" }}
//                                     className={"p-10 mx-1"}
//                                 >
//                                     <FaChevronLeft size={40} />
//                                 </div>

//                                 {images.length > 0 && (
//                                     <img
//                                         src={getImageByPosition(clickedImage)}
//                                         alt={`Nature ${clickedImage + 1}`}
//                                         onLoad={() => setImageLoaded(true)}
//                                         className="img-fluid"
//                                         style={{
//                                             objectFit: "contain",
//                                             width: "90vw",
//                                             height: "90vh",
//                                             filter: imageLoaded ? "none" : "blur(10px)", // blurred until loaded
//                                             opacity: imageLoaded ? 1 : 0,
//                                             transition: "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
//                                             backgroundColor: "transparent",
//                                         }}
//                                     />
//                                 )}

//                                 <div
//                                     onClick={() => setClickedImage((prev) => (prev + 1) % images.length)}
//                                     style={{ cursor: "pointer", color: "lightgray" }}
//                                     className={"p-10 mx-1"}
//                                 >
//                                     <FaChevronRight size={40} />
//                                 </div>
//                             </div>
//                         </Modal.Body>
//                     </Modal>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default PictureOpenModal;

import React, { useEffect, useState } from "react";
// import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import "./PictureOpenModal.css";
import Data from "../CottageItem/DataItems";

function PictureOpenModal({ clickedImageCategoryId, setClickedImageCategoryId }) {
    const [images, setImages] = useState([]);
    const [clickedImage, setClickedImage] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const getImageByPosition = (clickedImagePosition) => {
        if (clickedImagePosition < 0) {
            setClickedImage(images.length - 1);
            return images[images.length - 1]?.image;
        }
        if (clickedImagePosition >= images.length) {
            setClickedImage(0);
            return images[0]?.image;
        }
        return images[clickedImagePosition]?.image;
    };

    const handlePrevImage = () => {
        setClickedImage((prev) => (prev - 1 + images.length) % images.length);
    };

    const handleNextImage = () => {
        setClickedImage((prev) => (prev + 1) % images.length);
    };

    const handleKeyDown = (e) => {
        if (e.key === "ArrowLeft") {
            handlePrevImage();
        } else if (e.key === "ArrowRight") {
            handleNextImage();
        } else if (e.key === "Escape") {
            closeModal();
        }
    };

    const closeModal = () => {
        document.body.style.overflow = "auto";
        setIsModalOpen(false);
        setTimeout(() => {
            setClickedImageCategoryId(null);
        }, 300); // Wait for animation to complete before removing from DOM
    };

    useEffect(() => {
        if (clickedImageCategoryId !== null) {
            setIsModalOpen(true);
            document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
            const filteredCategory = Data.filter((item) => item.categoryId === clickedImageCategoryId);
            setImages(filteredCategory);
            setClickedImage(0); // Default to the first image in the category
        }
    }, [clickedImageCategoryId]);

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [images, clickedImage]);

    useEffect(() => {
        if (images.length > 0 && clickedImage !== null) {
            const img = new Image();
            img.src = getImageByPosition(clickedImage) || "";
            setIsLoading(true);
            img.onload = () => {
                setIsLoading(false);
            };
        }
    }, [clickedImage, images]);

    if (!isModalOpen || clickedImageCategoryId === null) {
        return null;
    }

    return (
        <div className={`modal-fullscreen ${isModalOpen ? "show" : ""}`}>
            {/* Close button */}
            <button onClick={closeModal} className="close-btn" aria-label="Close modal">
                <FaXmark size={20} className={"p-10"} />
            </button>

            {/* Navigation arrows */}
            <button onClick={handlePrevImage} className="nav-arrow-btn prev-btn" aria-label="Previous image">
                <FaChevronLeft size={32} />
            </button>

            <button onClick={handleNextImage} className="nav-arrow-btn next-btn" aria-label="Next image">
                <FaChevronRight size={32} />
            </button>

            {/* Image counter */}
            <div className="image-counter">
                {clickedImage + 1} / {images.length}
            </div>

            {/* <img src={getImageByPosition(clickedImage)} alt={`Gallery image ${clickedImage + 1}`} className="main-image fade-in" /> */}

            {/* Main image container */}
            <div className="image-container">
                {isLoading ? (
                    <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden"></span>
                    </div>
                ) : (
                    <img
                        src={getImageByPosition(clickedImage)}
                        alt={`Nature ${clickedImage + 1}`}
                        className="img-fluid main-iamge fade-in"
                        style={{
                            objectFit: "contain",
                            width: "90vw",
                            height: "90vh",

                            transition: "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
                            backgroundColor: "transparent",
                        }}
                    />
                )}
            </div>
        </div>
    );
}

export default PictureOpenModal;
